import Content from "../components/AMC/Content";
import i18n from "../resources/I18n";
import { INavigationParcours } from "../util/Navigation";

interface IPageAMCProps {
  parcours: string;
  cookieParcoursAssurance: INavigationParcours;
}

function PageAMC(props: Readonly<IPageAMCProps>) {
  return (
    <div data-test-id="page-amc" className="App">
      <span
        id="chargement-termine-amc"
        data-testid="chargement-termine-amc"
        className={"dsd-sr-only"}
        tabIndex={-1}
        aria-hidden={true}
      >
        {i18n.t("amc:sr-only-chargement-termine")}
      </span>
      <Content cookieParcoursAssurance={props.cookieParcoursAssurance} parcours={props.parcours} />
    </div>
  );
}

export default PageAMC;
